import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Footer } from 'src/shared';
import { ReactComponent as UltrasoundIcon } from 'src/assets/icons/ultrasound.svg';


const UltrasonicContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 25%, #2d2d2d 50%, #1a1a1a 75%, #0f0f0f 100%);
  color: #ffffff;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(15, 15, 15, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 2px solid #404040;
`;

const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid #606060;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: #808080;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin: 0;
  color: #ffffff;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.8);
`;

const Content = styled.div`
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const UltrasonicCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 2px solid #404040;
  padding: 4vh 3vw;
  max-width: 80vw;
  min-width: 300px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    padding: 30px;
    max-width: 95vw;
  }
  
  @media (min-width: 1200px) {
    padding: 50px;
    max-width: 800px;
  }
`;

const UltrasonicIconContainer = styled.div`
  width: 8vw;
  height: 8vw;
  min-width: 60px;
  min-height: 60px;
  max-width: 120px;
  max-height: 120px;
  margin-bottom: 2vh;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 100%;
    height: 100%;
    filter: brightness(0) invert(1) drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));
  }
`;

const UltrasonicTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #ffffff;
`;

const UltrasonicDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0.9;
  text-align: left;
`;

const FeatureList = styled.ul`
  text-align: left;
  font-size: 1rem;
  line-height: 1.8;
  opacity: 0.9;
`;

const DatasetSection = styled.div`
  margin-top: 40px;
  width: 100%;
  max-width: 1200px;
`;

const DatasetTitle = styled.h3`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #ffffff;
  text-align: center;
`;

const DatasetGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2vh 2vw;
  margin-top: 3vh;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  @media (min-width: 1200px) {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 30px;
  }
`;

const DatasetCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  border: 2px solid #404040;
  padding: 2.5vh 2vw;
  min-padding: 20px;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-8px);
    background: rgba(255, 255, 255, 0.1);
    border-color: #606060;
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.5);
  }
  
  @media (max-width: 768px) {
    padding: 20px;
  }
  
  @media (min-width: 1200px) {
    padding: 30px;
  }
`;

const DatasetIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 15px;
  text-align: center;
`;

const DatasetName = styled.h4`
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: #ffffff;
`;

const DatasetDescription = styled.p`
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 15px;
  opacity: 0.9;
`;

const DatasetStats = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  margin-bottom: 15px;
  opacity: 0.8;
`;

const DatasetLink = styled.a`
  display: inline-block;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 1px solid #606060;
  
  &:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: #808080;
    transform: translateY(-2px);
  }
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  gap: 10px;
`;

const TabButton = styled.button<{ active: boolean }>`
  background: ${props => props.active ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)'};
  border: 2px solid ${props => props.active ? '#808080' : '#404040'};
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: #606060;
    transform: translateY(-2px);
  }
`;

const Ultrasonic: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'fetal' | 'cardiac' | 'general'>('fetal');

  // Fetal ultrasound datasets
  const fetalDatasets = [
    {
      name: 'Fetal Heart Ultrasound Dataset',
      icon: '💓',
      description: 'Comprehensive dataset of fetal heart ultrasound images for congenital heart defect detection',
      images: '2,500+',
      patients: '500+',
      annotations: 'Expert-labeled',
      link: 'https://github.com/ieee8023/covid-chestxray-dataset',
      source: 'IEEE Medical Imaging'
    }
  ];

  // Cardiac ultrasound datasets
  const cardiacDatasets = [
    {
      name: 'EchoNet-Dynamic',
      icon: '🫀',
      description: 'Large-scale echocardiogram dataset with cardiac function analysis',
      images: '10,000+',
      patients: '2,000+',
      annotations: 'Video sequences',
      link: 'https://echonet.github.io/dynamic/',
      source: 'Stanford Medicine'
    },
    {
      name: 'CAMUS Dataset',
      icon: '📊',
      description: 'Multi-center cardiac ultrasound dataset for segmentation and analysis',
      images: '1,000+',
      patients: '500+',
      annotations: 'Pixel-level',
      link: 'https://camus.creatis.insa-lyon.fr/',
      source: 'CREATIS Laboratory'
    }
  ];

  // General ultrasound datasets
  const generalDatasets = [
    {
      name: 'POCUS Dataset',
      icon: '🏥',
      description: 'Point-of-care ultrasound dataset for emergency medicine applications',
      images: '8,000+',
      patients: '1,500+',
      annotations: 'Multi-organ',
      link: 'https://github.com/ieee8023/covid-chestxray-dataset',
      source: 'Emergency Medicine'
    }
  ];

  const getCurrentDatasets = () => {
    switch (activeTab) {
      case 'fetal':
        return fetalDatasets;
      case 'cardiac':
        return cardiacDatasets;
      case 'general':
        return generalDatasets;
      default:
        return fetalDatasets;
    }
  };

  return (
    <UltrasonicContainer>
      <Header>
        <BackButton onClick={() => navigate('/medical_imaging')}>
          ← Back to Medical Imaging
        </BackButton>
        <Title>Ultrasonic Imaging</Title>
        <div style={{ width: '120px' }}></div>
      </Header>

      <Content>
        <UltrasonicCard>
          <UltrasonicIconContainer>
            <UltrasoundIcon />
          </UltrasonicIconContainer>
          <UltrasonicTitle>Ultrasound Imaging</UltrasonicTitle>
          <UltrasonicDescription>
            Real-time ultrasound imaging technology for non-invasive examination of 
            internal organs, blood flow, and soft tissue structures. Explore open-source 
            datasets for fetal heart ultrasound, cardiac imaging, and general ultrasound applications.
          </UltrasonicDescription>
          
          <FeatureList>
            <li><strong>Real-time Imaging:</strong> Live internal structure visualization</li>
            <li><strong>Doppler Analysis:</strong> Blood flow velocity measurement</li>
            <li><strong>Organ Examination:</strong> Liver, kidney, heart, and fetal imaging</li>
            <li><strong>Portable Scanning:</strong> Bedside and emergency imaging</li>
            <li><strong>3D/4D Imaging:</strong> Volumetric and time-based visualization</li>
            <li><strong>AI Processing:</strong> Automated measurement and analysis</li>
          </FeatureList>
        </UltrasonicCard>

        {/* Dataset Gallery */}
        <DatasetSection>
          <DatasetTitle>📊 Open-Source Ultrasound Datasets</DatasetTitle>
          
          <TabContainer>
            <TabButton 
              active={activeTab === 'fetal'} 
              onClick={() => setActiveTab('fetal')}
            >
              👶 Fetal Ultrasound
            </TabButton>
            <TabButton 
              active={activeTab === 'cardiac'} 
              onClick={() => setActiveTab('cardiac')}
            >
              🫀 Cardiac Ultrasound
            </TabButton>
            <TabButton 
              active={activeTab === 'general'} 
              onClick={() => setActiveTab('general')}
            >
              🏥 General Ultrasound
            </TabButton>
          </TabContainer>

          <DatasetGrid>
            {getCurrentDatasets().map((dataset, index) => (
              <DatasetCard key={index} onClick={() => window.open(dataset.link, '_blank')}>
                <DatasetIcon>{dataset.icon}</DatasetIcon>
                <DatasetName>{dataset.name}</DatasetName>
                <DatasetDescription>{dataset.description}</DatasetDescription>
                
                <DatasetStats>
                  <span>📸 {dataset.images} images</span>
                  <span>👥 {dataset.patients} patients</span>
                </DatasetStats>
                
                <DatasetStats>
                  <span>🏷️ {dataset.annotations}</span>
                  <span>📚 {dataset.source}</span>
                </DatasetStats>
                
                <DatasetLink href={dataset.link} target="_blank" rel="noopener noreferrer">
                  🔗 Explore Dataset
                </DatasetLink>
              </DatasetCard>
            ))}
          </DatasetGrid>
        </DatasetSection>
      </Content>

      <Footer />
    </UltrasonicContainer>
  );
};

export default Ultrasonic;
